"use strict";
'use client';
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Switch = void 0;
var React = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _composeClasses = require("../composeClasses");
var _useSwitch = require("../useSwitch");
var _utils = require("../utils");
var _ClassNameConfigurator = require("../utils/ClassNameConfigurator");
var _switchClasses = require("./switchClasses");
var _jsxRuntime = require("react/jsx-runtime");
var useUtilityClasses = function(ownerState) {
    var checked = ownerState.checked, disabled = ownerState.disabled, focusVisible = ownerState.focusVisible, readOnly = ownerState.readOnly;
    var slots = {
        root: [
            'root',
            checked && 'checked',
            disabled && 'disabled',
            focusVisible && 'focusVisible',
            readOnly && 'readOnly'
        ],
        thumb: [
            'thumb'
        ],
        input: [
            'input'
        ],
        track: [
            'track'
        ]
    };
    return (0, _composeClasses.unstable_composeClasses)(slots, (0, _ClassNameConfigurator.useClassNamesOverride)(_switchClasses.getSwitchUtilityClass));
};
/**
 * The foundation for building custom-styled switches.
 *
 * Demos:
 *
 * - [Switch](https://mui.com/base-ui/react-switch/)
 *
 * API:
 *
 * - [Switch API](https://mui.com/base-ui/react-switch/components-api/#switch)
 */ var Switch = exports.Switch = /*#__PURE__*/ React.forwardRef(function Switch(props, forwardedRef) {
    var checkedProp = props.checked, defaultChecked = props.defaultChecked, disabledProp = props.disabled, onBlur = props.onBlur, onChange = props.onChange, onFocus = props.onFocus, onFocusVisible = props.onFocusVisible, readOnlyProp = props.readOnly, required = props.required, _props_slotProps = props.slotProps, slotProps = _props_slotProps === void 0 ? {} : _props_slotProps, _props_slots = props.slots, slots = _props_slots === void 0 ? {} : _props_slots, other = _object_without_properties(props, [
        "checked",
        "defaultChecked",
        "disabled",
        "onBlur",
        "onChange",
        "onFocus",
        "onFocusVisible",
        "readOnly",
        "required",
        "slotProps",
        "slots"
    ]);
    var _ref = (0, _useSwitch.useSwitch)(props), getInputProps = _ref.getInputProps, checked = _ref.checked, disabled = _ref.disabled, focusVisible = _ref.focusVisible, readOnly = _ref.readOnly;
    var ownerState = _object_spread_props(_object_spread({}, props), {
        checked: checked,
        disabled: disabled,
        focusVisible: focusVisible,
        readOnly: readOnly
    });
    var classes = useUtilityClasses(ownerState);
    var _slots_root;
    var Root = (_slots_root = slots.root) !== null && _slots_root !== void 0 ? _slots_root : 'span';
    var rootProps = (0, _utils.useSlotProps)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            ref: forwardedRef
        },
        ownerState: ownerState,
        className: classes.root
    });
    var _slots_thumb;
    var Thumb = (_slots_thumb = slots.thumb) !== null && _slots_thumb !== void 0 ? _slots_thumb : 'span';
    var thumbProps = (0, _utils.useSlotProps)({
        elementType: Thumb,
        externalSlotProps: slotProps.thumb,
        ownerState: ownerState,
        className: classes.thumb
    });
    var _slots_input;
    var Input = (_slots_input = slots.input) !== null && _slots_input !== void 0 ? _slots_input : 'input';
    var inputProps = (0, _utils.useSlotProps)({
        elementType: Input,
        getSlotProps: getInputProps,
        externalSlotProps: slotProps.input,
        ownerState: ownerState,
        className: classes.input
    });
    var _slots_track;
    var Track = slots.track === null ? function() {
        return null;
    } : (_slots_track = slots.track) !== null && _slots_track !== void 0 ? _slots_track : 'span';
    var trackProps = (0, _utils.useSlotProps)({
        elementType: Track,
        externalSlotProps: slotProps.track,
        ownerState: ownerState,
        className: classes.track
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Root, _object_spread_props(_object_spread({}, rootProps), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Track, _object_spread({}, trackProps)),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Thumb, _object_spread({}, thumbProps)),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Input, _object_spread({}, inputProps))
        ]
    }));
});
process.env.NODE_ENV !== "production" ? Switch.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * If `true`, the component is checked.
   */ checked: _propTypes.default.bool,
    /**
   * Class name applied to the root element.
   */ className: _propTypes.default.string,
    /**
   * The default checked state. Use when the component is not controlled.
   */ defaultChecked: _propTypes.default.bool,
    /**
   * If `true`, the component is disabled.
   */ disabled: _propTypes.default.bool,
    /**
   * @ignore
   */ onBlur: _propTypes.default.func,
    /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */ onChange: _propTypes.default.func,
    /**
   * @ignore
   */ onFocus: _propTypes.default.func,
    /**
   * @ignore
   */ onFocusVisible: _propTypes.default.func,
    /**
   * If `true`, the component is read only.
   */ readOnly: _propTypes.default.bool,
    /**
   * If `true`, the `input` element is required.
   */ required: _propTypes.default.bool,
    /**
   * The props used for each slot inside the Switch.
   * @default {}
   */ slotProps: _propTypes.default.shape({
        input: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object
        ]),
        root: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object
        ]),
        thumb: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object
        ]),
        track: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside the Switch.
   * Either a string to use a HTML element or a component.
   * @default {}
   */ slots: _propTypes.default/* @typescript-to-proptypes-ignore */ .shape({
        input: _propTypes.default.elementType,
        root: _propTypes.default.elementType,
        thumb: _propTypes.default.elementType,
        track: _propTypes.default.oneOfType([
            _propTypes.default.elementType,
            _propTypes.default.oneOf([
                null
            ])
        ])
    })
} : void 0;
